import React from "react";
import "./skeleton.css";

const ProjectSkeleton = () => {
  return (
    <div>
      <div className="flex items-center justify-start py-2 flex-row SKeletonScale">
        <div className="w-[23%] flex items-center justify-start">
          <div className="line w-[12rem] h-[0.8rem] rounded-md"></div>
        </div>
        <div className="w-[13%] flex justify-center items-center">
          <div className="line w-[3rem] h-[0.8rem] rounded-md"></div>
        </div>
        <div className="w-[27%] flex justify-center items-center"> {/* Added margin-left of 1rem */}
          <div className="line2  line w-[9.5rem] h-[1.9rem] rounded"></div>
        </div>
        <div className="w-[22%] flex justify-center items-center">
          <div className="line3 line w-[13rem] h-[0.8rem] rounded-md"></div>
        </div>
        <div className="skeletonOption flex items-center justify-center gap-2 3xl:gap-3 line4 w-[25%] ">
          <div className="line w-[1.5rem] h-[1.5rem] rounded"></div>
          <div className="line w-[1.5rem] h-[1.5rem] rounded"></div>
          <div className="line w-[1.5rem] h-[1.5rem] rounded"></div>
          <div className="line w-[1.5rem] h-[1.5rem] rounded"></div>
        </div>
        <div className="w-[10%] justify-center flex items-center ">
          <div className="line w-[1.5rem] h-[1.5rem] rounded-full"></div>
        </div>
      </div>
      <div className="w-full justify-center flex items-center bg-gray-700 h-[0.07rem]"></div>
    </div>
  );
};

export default ProjectSkeleton;
